// Cellery Soapbox — app header (brand chrome).
// Navy wordmark links home; shows the signed-in user + sign-out, or a
// sign-in affordance when signed out.

import { Link } from "react-router-dom";
import { useAuth } from "../auth";
import { Wordmark } from "./Wordmark";
import { Icon } from "./Icon";

export function Header() {
  const { user, emailLower, signOut } = useAuth();

  return (
    <header className="app-header">
      <Link to="/" aria-label="Cellery Soapbox — home">
        <Wordmark />
      </Link>

      {/* Signed out: the sign-in screen is the single CTA (no header button). */}
      {user && (
        <div className="user-box">
          <span className="user-email" title={emailLower}>
            {emailLower}
          </span>
          <button
            type="button"
            className="btn btn-ghost"
            onClick={() => void signOut()}
          >
            <Icon name="sign-out" size={18} />
            Sign out
          </button>
        </div>
      )}
    </header>
  );
}
